import React from 'react';
import { Aligner } from '@alfa-bank/site-aligner';
import { ImgV2 } from '@alfa-bank/site-img-v2';
import cn from 'classnames';

import type { TRatesTableBody } from './models';

export const RatesTableBody = ({
    Skeleton,
    Text,
    fontConfig: { currency, view },
    isMobile,
    loading,
    rates,
    rowsCount,
    styles,
}: TRatesTableBody) => {
    if (loading) return <Skeleton isMobile={isMobile} rowsCount={rowsCount} />;

    return (
        <tbody>
            {rates.map(({ buy, iconUrl, name, sell }) => (
                <tr
                    key={name + buy}
                    className={cn(styles.row, styles.borderLine, {
                        [styles.firstBorderLineMobile]: isMobile,
                    })}
                >
                    <td className={cn(styles.external, styles.firstColumn)}>
                        <Aligner
                            align={'left'}
                            className={cn(styles.external, styles.horizontalAligne)}
                        >
                            {iconUrl && (
                                <ImgV2
                                    height={24}
                                    lazy={false}
                                    src={iconUrl}
                                    styler={{ marginRight: 8 }}
                                    width={24}
                                />
                            )}
                            <Text
                                styler={{ marginTop: 0, marginBottom: 0 }}
                                tag="span"
                                view={currency}
                            >
                                {name}
                            </Text>
                        </Aligner>
                    </td>
                    <td align="right" className={cn(styles.external, styles.restColumn)}>
                        <Aligner align={'right'}>
                            <Text styler={{ marginTop: 0, marginBottom: 0 }} tag="span" view={view}>
                                {buy}
                            </Text>
                        </Aligner>
                    </td>
                    <td align="right" className={cn(styles.external, styles.restColumn)}>
                        <Aligner align={'right'}>
                            <Text styler={{ marginTop: 0, marginBottom: 0 }} tag="span" view={view}>
                                {sell}
                            </Text>
                        </Aligner>
                    </td>
                </tr>
            ))}
        </tbody>
    );
};
